"use strict";
exports.__esModule = true;
var result_1 = require("./result");
exports.ok = result_1.ok;
exports.Ok = result_1.Ok;
exports.err = result_1.err;
exports.Err = result_1.Err;
var result_async_1 = require("./result-async");
exports.ResultAsync = result_async_1.ResultAsync;
exports.okAsync = result_async_1.okAsync;
exports.errAsync = result_async_1.errAsync;
var chain_1 = require("./chain");
exports.chain = chain_1.chain;
exports.chain3 = chain_1.chain3;
exports.chain4 = chain_1.chain4;
exports.chain5 = chain_1.chain5;
exports.chain6 = chain_1.chain6;
exports.chain7 = chain_1.chain7;
exports.chain8 = chain_1.chain8;
